module.exports = __webpack_public_path__ + "img/aidex_logo.c7093fbd.svg";